import { useEffect, useState } from 'react';

import { toast } from 'react-toastify';

import { apiOrchestrator } from 'services/apiService';
import { isValidImageUrl } from 'utils/imageValidation';

interface UseCompanyImageReturn {
  companyImage: string | null;
  loading: boolean;
  error: string | null;
  updateCompanyImage: (file: File) => Promise<void>;
  deleteCompanyImage: () => Promise<void>;
}

const useCompanyImage = (companyUuid: string): UseCompanyImageReturn => {
  const [companyImage, setCompanyImage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCompanyImage = async () => {
    if (!companyUuid) return;

    try {
      setLoading(true);
      setError(null);
      const response = await apiOrchestrator.get(`/companies/logo/${companyUuid}`);
      const imageUrl = response.data;

      if (true) {
        const isValid = await isValidImageUrl(imageUrl);
        if (true) {
          setCompanyImage(imageUrl);
        } else {
          setError('Imagem da empresa inválida ou inacessível');
          setCompanyImage(null);
        }
      } else {
        setCompanyImage(null);
      }
    } catch (error) {
      setError('Erro ao carregar imagem da empresa');
      console.error('Erro ao carregar imagem da empresa:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyImage();
  }, [companyUuid]);

  const updateCompanyImage = async (file: File) => {
    if (!companyUuid) {
      setError('ID da empresa não fornecido');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const formData = new FormData();
      formData.append('image', file);

      const response = await apiOrchestrator.post(
        `/companies/upload-logo/${companyUuid}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const newImageUrl = response.data;
      // const isValid = await isValidImageUrl(newImageUrl);

      if (response.data.status === 'success') {
        // setCompanyImage(newImageUrl);
        fetchCompanyImage();
        toast.success('Logo da empresa atualizada com sucesso!');
      } else {
        setError('Imagem inválida ou inacessível');
        toast.error('Erro ao validar a nova imagem');
      }
    } catch (error) {
      setError('Erro ao atualizar imagem da empresa');
      toast.error('Erro ao atualizar logo da empresa');
      console.error('Erro ao atualizar imagem da empresa:', error);
    } finally {
      setLoading(false);
    }
  };

  const deleteCompanyImage = async () => {
    if (!companyUuid) {
      setError('ID da empresa não fornecido');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      await apiOrchestrator.delete(`/companies/${companyUuid}/image`);
      setCompanyImage(null);
      toast.success('Logo da empresa removida com sucesso!');
    } catch (error) {
      setError('Erro ao remover imagem da empresa');
      toast.error('Erro ao remover logo da empresa');
      console.error('Erro ao remover imagem da empresa:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    companyImage,
    loading,
    error,
    updateCompanyImage,
    deleteCompanyImage,
  };
};

export default useCompanyImage;
